<template>
  <CSidebar
    fixed
    :minimize="minimize"
    :show="show"
    breakpoint="lg" 
    class="bg-style1 sidebar-below-header"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CRenderFunction flat :contentToRender="navs"/>
  </CSidebar>
</template>

<script>
export default {
  name: 'TheSidebar',
  computed: {
    show() {
      return this.$store.state.sidebarShow
    },
    minimize() {
      return this.$store.state.sidebarMinimize
    },
    navs() {
      void this.$store.state.locale.lang
      return [{
        _name: 'CSidebarNav',
        _children: [
          {
            _name: 'CSidebarNavItem',
            name: this.$t('nav.repairs'),
            to: '/technician/reportlist',
            icon: 'cil-window-restore'
          },
          {
            _name: 'CSidebarNavItem',
            name: this.$t('nav.userManual'),
            to: '/technician/manual',
            icon: 'cil-book'
          },
        ]
      }]
    },
  },
}
</script>

<style scoped>
.bg-style1 {
  background: linear-gradient(30deg, #FFF0C4 0%, #145654 40%);
}

.sidebar-below-header {
  top: 66px !important; 
  height: calc(100vh - 66px) !important;
  z-index: 1029;
  /* เพิ่ม Shadow เพื่อให้ดูมีมิติเวลาทับบนมือถือ */
  box-shadow: 2px 0 10px rgba(0,0,0,0.1); 
}

/* ปรับให้ในมือถือ Sidebar เต็มจอกว่าเดิม */
@media (max-width: 991.98px) {
  .sidebar-below-header {
     /* ในมือถือ ถ้าอยากให้ sidebar ทับ header ไปเลย ให้แก้ top เป็น 0 */
     /* แต่ถ้าจะให้อยู่ใต้ header เหมือนเดิม ค่าเดิมโอเคแล้ว */
  }
}

::v-deep .c-sidebar-nav-link {
  color: #ffffff;
  transition: all 0.25s ease;
  border-radius: 8px;
  margin: 4px 8px;
  position: relative;
  overflow: hidden;
}

::v-deep .c-sidebar-nav-link:hover {
  background: rgba(255, 255, 255, 0.15);
  transform: translateX(4px);
}

::v-deep .c-sidebar-nav-link .c-sidebar-nav-icon {
  transition: transform 0.25s ease;
}

::v-deep .c-sidebar-nav-link:hover .c-sidebar-nav-icon {
  transform: scale(1.1);
}

::v-deep .c-sidebar-nav-link.c-active {
  background: rgba(255, 255, 255, 0.25);
  font-weight: 700;
}

::v-deep .c-sidebar-nav-link.c-active::before {
  content: "";
  position: absolute;
  left: 0;
  top: 8px;
  bottom: 8px;
  width: 4px;
  border-radius: 4px;
  background: #ffd666;
}

::v-deep .c-sidebar-nav {
  animation: sidebarFadeIn 0.4s ease;
}

@keyframes sidebarFadeIn {
  from { opacity: 0; transform: translateX(-10px); }
  to { opacity: 1; transform: translateX(0); }
}
</style>